import React from 'react';
import { Badge } from '../ui/badge';

const STATUS_MAP = {
  not_clocked_in: { label: 'Not Clocked In', className: 'bg-[#3F3F46] text-white' },
  clocked_in: { label: 'Clocked In', className: 'bg-[#00E676]/20 text-[#00E676] border border-[#00E676]/40' },
  on_break: { label: 'On Break', className: 'bg-[#FFB300]/20 text-[#FFB300] border border-[#FFB300]/40' },
  closed: { label: 'Closed', className: 'bg-[#3F3F46] text-white' },
  open: { label: 'Open', className: 'bg-[#00E676]/20 text-[#00E676] border border-[#00E676]/40' },
};

export default function AttendanceStatusBadge({ status }) {
  const key = String(status || '').toLowerCase();
  const mapped = STATUS_MAP[key] || {
    label: status || 'Unknown',
    className: 'bg-[#27272A] text-[#A1A1AA] border border-[#3F3F46]',
  };

  return <Badge className={mapped.className}>{mapped.label}</Badge>;
}
